import crearDireccion from "../direccion/crear";
import mensajeError from "../../mensajes/MensajeError";
import mensajePreventivo from "../../mensajes/mensajePreventivo";

export default async function crearContribuyente(data, setData) {
    const { contribuyente } = data;
    // Obligatorio: Nombre, apellidos, rfc, curp y nacimiento
    if (Object.keys(data).includes("contribuyente") && contribuyente.nombre && contribuyente.apellidoPaterno
        && contribuyente.apellidoMaterno && contribuyente.rfc && contribuyente.curp && contribuyente.fechaNacimiento) {

        // Logitud requerida para el RFC
        if (contribuyente.rfc.length < 10) {
            mensajeError("Se requiren de al menos 10 caracteres para el campo RFC");
        }

        // Longitud requerida para el CURP
        if (data?.contribuyente.curp.length < 10) {
            mensajeError("Se requiren de al menos 10 caracteres para el campo CURP");
        }

        // Verifica que existan datos de la dirección
        else if (Object.keys(data).includes("direcciones")) {
            contribuyente.tipoPersona = contribuyente.tipoPersona ?? 0;
            contribuyente.idNacionalidad = contribuyente.idNacionalidad ?? 0
            contribuyente.idGenero = contribuyente.idGenero ?? 2;
            contribuyente.idEstadoCivil = contribuyente.idEstadoCivil ?? 1;
            contribuyente.mail = contribuyente.mail ?? "";
            contribuyente.idEstadoNacimiento = contribuyente.idEstadoNacimiento ?? 13;
            contribuyente.observaciones = contribuyente.observaciones ?? "";

            const settings = {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(contribuyente)
            };

            try {
                if (contribuyente.tipoPersona === 1) {
                    contribuyente.apellidoPaterno = "";
                    contribuyente.apellidoMaterno = "";
                }
                const dataResponse = await (await fetch("/api/contribuyente/crear", settings)).json();
                if (dataResponse.status === "Ok") {
                    setData({ contribuyente: dataResponse.data });
                    crearDireccion(data.direcciones[0], data, setData, dataResponse.data.idContribuyente);
                } else mensajeError("Fue imposible crear contribuyente");

            }
            catch (err) {
                let mensajeDeError;
                if (contribuyente === undefined) mensajeDeError = "Hay campos vacíos";
                else mensajeDeError = `Error: ${err}`;
                mensajeError(mensajeDeError);
            }
        } else mensajePreventivo("Ingresa datos de dirección");
    } else mensajePreventivo("Datos del contribuyente incompletos");
}